import { gql } from "@apollo/client";

export const RegionList = gql`
    query RegionList {
        regionList {
            total
            regions {
                id
                name
            }
        }
    }
`;
